module.exports = __webpack_public_path__ + "img/carrousel-pacs-3.32bc4b74.png";